<ng-container *ngIf="symbol()">
  <img [attr.height]="height()" [attr.width]="width()" class="icon" [src]="weatherIcon" alt="">
</ng-container>

